var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMidPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    preserveAspectRatio: "none",
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_359_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 1.89678L15 0H0V24.917L0.52 25.5H29.4116L30 24.9116V2.7L29.5 2.02309H17.3C17.1842 2.02309 17.0829 1.97791 17 1.89678Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015 0.015H14.994L16.9895 1.9075C16.9895 1.90753 16.9896 1.90755 16.9896 1.90758C17.075 1.99115 17.18 2.03809 17.3 2.03809H29.4924L29.985 2.70494V24.9054L29.4054 25.485H0.526722L0.015 24.9113V0.015Z",
    stroke: "url(#paint0_linear_359_8)",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015 0.015H14.994L16.9895 1.9075C16.9895 1.90753 16.9896 1.90755 16.9896 1.90758C17.075 1.99115 17.18 2.03809 17.3 2.03809H29.4924L29.985 2.70494V24.9054L29.4054 25.485H0.526722L0.015 24.9113V0.015Z",
    stroke: "url(#paint1_linear_359_8)",
    strokeWidth: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_359_8",
    x: -23,
    y: -23,
    width: 76,
    height: 71.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_359_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_359_8",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_8",
    x1: -0.632321,
    y1: -3.05559,
    x2: 20.0767,
    y2: 7.45202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_8",
    x1: 32.2219,
    y1: 31.3119,
    x2: 21.5835,
    y2: 27.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMidPad);
export default __webpack_public_path__ + "static/media/home_mid_pad.d22d8fb54cca727f4b40ce6753c6016b.svg";
export { ForwardRef as ReactComponent };